import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AutomapService {
  constructor(private _api: ApiService) {}

  getMetadata(): Observable<any> {
    const results = this._api.get(`/api/v1/mapping/metadata`).pipe(map((data) => data));
    return results;
  }

  getEntityConfig(): Observable<any> {
    const results = this._api.get(`/api/v1/mapping/config`).pipe(map((data) => data));
    return results;
  }

  getTerminologiesList(): Observable<any> {
    const results = this._api.get(`/terminology/config?type=codeSystemUri`).pipe(map((data) => data));
    return results;
  }

  getTerms(query: string, page: number, perPage: number, sort = '', ascending = true, batch = null): Observable<any> {
    const results = this._api
      .get(
        `/api/v1/mapping/term?query=${encodeURIComponent(query)}&offset=${page}&limit=${perPage}&sort=${sort}&ascending=${ascending}${batch ? `&batch=${encodeURIComponent(batch)}` : ''}`,
      )
      .pipe(map((data) => data));
    return results;
  }

  getTask(id: string): Observable<any> {
    const results = this._api.get(`/api/v1/mapping/task/${id}`).pipe(map((data) => data));
    return results;
  }

  getAudit(id: string): Observable<any> {
    const results = this._api.get(`/api/v1/mapping/term/${id}/audit?offset=0`).pipe(map((data) => data));
    return results;
  }

  findBatchIds(query?: string, offset?: number, limit?: number): Observable<any> {
    const results = this._api
      .get(`/api/v1/mapping/batch?query=${encodeURIComponent(query)}${offset ? `&offset=${offset}` : ''}${limit ? `&limit=${limit}` : ''}`)
      .pipe(map((data) => data));
    return results;
  }

  postTask(body: any): Observable<any> {
    const results = this._api.post(`/api/v1/mapping/task`, body).pipe(map((data) => data));
    return results;
  }

  patchStatus(id: string, status: string): Observable<any> {
    const results = this._api.patch(`/api/v1/mapping/term/${id}`, { id: id, status: status }).pipe(map((data) => data));
    return results;
  }

  postMapping(body: any): Observable<any> {
    const results = this._api.post(`/api/v1/mapping/term/finish`, body).pipe(map((data) => data));
    return results;
  }

  postSearchMap(body: any): Observable<any> {
    const results = this._api.post(`/api/v1/mapping/term`, body).pipe(map((data) => data));
    return results;
  }

  exportTerms(status: string): Observable<any> {
    const results = this._api.get(`/api/v1/mapping/term/export?query=status:${status}`).pipe(map((data) => data));
    return results;
  }

  getTermsTableExport(filename: string, query: string, batch: string): Observable<void> {
    const encodedQuery = encodeURIComponent(query);
    const encodedBatchClause = batch ? '&batch=' + encodeURIComponent(batch) : '';
    return this._api.getExport(`/api/v1/mapping/term/export?query=${encodedQuery}${encodedBatchClause}`, filename);
  }

  deleteTerm(termId): Observable<any> {
    return this._api.delete(`/api/v1/mapping/term/${termId}`).pipe(map((data) => data));
  }

  postFhirResource(body: any, confidence?: number | string): Observable<any> {
    return this._api
      .postJson(`/api/v1/mapping/fhir?audit=true${confidence != undefined ? `&minConfidence=${confidence}` : ''}`, body)
      .pipe(map((data) => data));
  }

  deleteBatch(batchId): Observable<any> {
    return this._api.delete(`/api/v1/mapping/batch/${batchId}`).pipe(map((data) => data));
  }
}
